// extracted by mini-css-extract-plugin
module.exports = {"inboxButton":"styles_inboxButton__labhf","unreadBadge":"styles_unreadBadge__1ouO1","modalContent":"styles_modalContent__mwU3r","modal":"styles_modal__2TlLn"};